import { PaymentsApi, useAPIQuery } from "melco-shared-logic";

export const usePaymentsGetTransDetails = (id: string | undefined) => {


    return useAPIQuery(PaymentsApi, ["paymentTransactionDetail", id], async (api) => {
        if (id == null) {
            return;
        }

        const data = await api.paymentsGetTransDetails({ id: id });

        return data
    });
};
